import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconPresentationMode = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsxs(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 25"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M15 23.323H9l.75-4.32h4.5l.75 4.32v0z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M6.75 23.323h10.5",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M.75 4.723a3 3 0 013-3h16.5a3 3 0 013 3v11.28a3 3 0 01-3 3H3.75a3 3 0 01-3-3V4.723z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M9.6 13.412V7.315c0-.26.145-.499.38-.627a.777.777 0 01.756.01l5.292 3.048c.226.13.365.364.365.617a.715.715 0 01-.365.618l-5.292 3.048a.777.777 0 01-.755.01.715.715 0 01-.38-.627h0z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
});
IconPresentationMode.displayName = "IconPresentationMode";

export { IconPresentationMode };
